import { render, staticRenderFns } from "./CommunityConsultation.vue?vue&type=template&id=4c5018ca&"
import script from "./CommunityConsultation.vue?vue&type=script&lang=js&"
export * from "./CommunityConsultation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports